(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8006],{

/***/ 21173:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password",
      function () {
        return __webpack_require__(29260);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37946);
/* harmony import */ var components_ModalInformation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18783);
/* harmony import */ var components_Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97059);
/* harmony import */ var services_apiClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81372);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  min-height: calc(100vh - (490px + 10px));\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  text-align: center;\n\n  h1 {\n    color: #4397c3;\n  }\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  input {\n    margin-top: 2rem;\n    width: 100%;\n    font-size: 1.5rem;\n    padding: 1rem 2rem;\n    border: solid 2px #4397c3;\n    border-radius: 10px;\n  }\n\n  input::placeholder {\n    font-size: 15px;\n    color: #174F68;\n    font-weight: 500;\n  }\n\n  input:hover {\n    border: solid 2px #4397c3;\n    color: #174F68;\n  }\n\n  input:focus,\n  select:focus {\n    box-shadow: 0.3px 0.3px 0.3px;\n    outline: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 10px;\n  text-align: center;\n  border: none;\n  font-weight: 700;\n  margin-top: 2.5rem;\n  padding: 1.2rem 1.2rem;\n  background: #4397c3;\n  font-size: 10px;\n  color: #fff;\n  cursor: pointer;\n  text-transform: uppercase;\n  transition: all 0.5s;\n\n  :hover {\n    opacity: 0.7;\n  }\n\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ResetPassword = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), userEmail = ref[0], setUserEmail = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showModalInformation = ref1[0], setShowModalInformation = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), messageInformation = ref2[0], setMessageInformation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("sucess"), typeMessage = ref3[0], setTypeMessage = ref3[1];
    var resetPassword = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            services_apiClient__WEBPACK_IMPORTED_MODULE_6__/* .api.post */ .h.post("/users/password", {
                                email: userEmail
                            })
                        ];
                    case 1:
                        _state.sent();
                        setMessageInformation("Sucesso! As informa\xe7\xf5es para recuperar sua senha foram enviadas para o seu e-mail.");
                        setTypeMessage("sucess");
                        setShowModalInformation(true);
                        setTimeout(function() {
                            setShowModalInformation(false);
                            next_router__WEBPACK_IMPORTED_MODULE_2___default().push("/login");
                        }, 4000);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setMessageInformation("Ocorreu um erro ao tentar recuperar a senha!");
                        setTypeMessage("error");
                        setShowModalInformation(true);
                        setTimeout(function() {
                            setShowModalInformation(false);
                        }, 5000);
                        console.log(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function resetPassword() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        navbar: true,
        title: "Resetar senha",
        margin: false,
        description: "Minim sint aliquip nostrud excepteur cupidatat amet do laborum exercitation cupidatat ea proident.",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_ModalInformation__WEBPACK_IMPORTED_MODULE_4__/* .ModalInformation */ .L, {
                modalIsOpen: showModalInformation,
                closeModal: setShowModalInformation,
                message: messageInformation,
                typeMessage: typeMessage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                        children: "Coloque seu e-mail para recuperar sua senha!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Group, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                            type: "email",
                            placeholder: "E-mail",
                            onChange: function(e) {
                                return setUserEmail(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                        onClick: resetPassword,
                        children: "Recuperar a senha"
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ResetPassword);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-115ef02f-0"
})(_templateObject());
var Group = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-115ef02f-1"
})(_templateObject1());
var Button = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-115ef02f-2"
})(_templateObject2());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,9866,1228,8907,4702,6804,7059,9774,2888,179], function() { return __webpack_exec__(21173); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);